module.exports = __webpack_public_path__ + "media/images/flags/TH-a6a66cccacb0ee36da8c85b7246bf9c7.svg";